<template>
    <div>
        <Loading :value="loading"></Loading>
        <v-dialog v-model="dialogTarifLocation" max-width="70%" transition="dialog-bottom-transition" scrollable :loading="loading" persistent>
            <v-card>
                <v-toolbar card dark color="green">
                    <v-toolbar-title>Liste des forfaits de tarification</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click.native="closeDialog()"> <v-icon>close</v-icon> </v-btn>
                </v-toolbar>
                <v-card-text>
                    <p align="center">
                        <v-chip text-color="white" label color="green" style="width: 100%">
                          LISTE DES FORFAITS DE TARIFICATION POUR LES LOCATIONS DE VEHICULE 
                        </v-chip>
                    </p>
                    <v-spacer></v-spacer>
                    <div class="text-xs-right">
                        <!--Bouton ajouter tarifs-->

                        <v-flex xs3 >
                              <el-col :span="2" >
                                <el-popover
                                ref="popover5"
                                placement="top"
                                width="180"
                                trigger="hover"
                                >
                                  <p>Veuillez choisir le format d'impression ?</p>
                                  <div style="text-align: right; margin: 0">
                                    <el-button type="success" size="mini" @click="imprimeListeTarif('PDF')">PDF</el-button>
                                    <el-button type="primary" size="mini" @click="imprimeListeTarif('EXC')">EXCEL</el-button>
                                  </div>
                                </el-popover>
                                  <div>
                                    <el-button v-popover:popover5 type="warning" :disabled="disabledBtnTar"
                                        icon="el-icon-printer" >Imprimer la liste
                                    </el-button>
                                  </div>
                              </el-col>
                            </v-flex> <br/><br/>
                        
                        <v-tooltip top>
                            <v-btn slot="activator" color="primary" @click.stop="newTarif()" dark>
                                Ajouter <v-icon center>add</v-icon>
                            </v-btn>
                            Ajouter une nouvelle tarification
                        </v-tooltip>
                    </div>
                    
                    <v-container fluid grid-list-md>
                        <data-tables :data="itemsTarif" style="width: 100%">
                            <el-table-column prop="tarification" label="Tarification" width="270" fixed="left">
                                <template slot-scope="scope">
                                    <v-chip label text-color="white" color="primary">
                                        {{scope.row.tarification}}
                                    </v-chip>
                                </template>
                            </el-table-column>
                            <el-table-column prop="vehicule" label="Vehicule" width="300">
                                <template slot-scope="scope">
                                    <v-chip label text-color="white" color="green">
                                        {{scope.row.vehicule}}
                                    </v-chip>
                                </template>
                            </el-table-column>
                            <el-table-column prop="montant" label="Montant" width="200">
                                <template slot-scope="scope">
                                    <v-chip outline label text-color="primary" color="primary">
                                    {{scope.row.montant}} FCFA
                                    </v-chip>
                                </template>
                            </el-table-column>
                            <el-table-column prop="unite" label="Unité" width="160">
                                <template slot-scope="scope">
                                    <v-chip label text-color="white" color="orange">
                                        {{scope.row.unite}}
                                    </v-chip>
                                </template>
                            </el-table-column>
                            <el-table-column label="Action" fixed="right">
                                <template slot-scope="scope">
                                  <div class="text-xs-center">
                                    <v-tooltip top>
                                      <v-btn slot="activator" @click="editTarification(scope.row)" fab dark small color="primary">
                                        <v-icon dark>edit</v-icon>
                                      </v-btn>
                                      Modifier
                                    </v-tooltip>
                                  </div>
                                </template>
                            </el-table-column>
                        </data-tables>
                    </v-container>
                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>

        <!-- AJOUT FORMULAIRE DE TARIFICATION -->
        <v-dialog v-model="dialogAjoutTarif" :persistent="true" max-width="50%" :loading="loading">
            <v-card>
                <v-toolbar light :dense="true" dark color="primary">
                    <v-toolbar-title>Ajouter une nouvelle tarification pour la location</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click.native="dialogAjoutTarif = false"> <v-icon>close</v-icon> </v-btn>
                </v-toolbar>

                <v-card-text>
                    <v-container fluid grid-list-md>
                        <p align="center">
                          <v-chip text-color="white" label color="primary" style="width: 100%">
                            AJOUT D'UNE NOUVELLE TARIFICATION POUR LES LOCATION DE VEHICULE
                          </v-chip>
                        </p>
                        <v-form v-model="valid" ref="formAjoutTarifForfait" lazy-validation id="formAjoutTarifForfait">
                            <v-layout row>
                                <v-flex md6>
                                  <div class="block">
                                    <span class="demonstration">Tarification *</span>
                                    <el-autocomplete v-model="selectTarification" :fetch-suggestions="loadTarification" placeholder="Tarification" :trigger-on-focus="true" style="width: 100%"></el-autocomplete>
                                  </div>
                                </v-flex>
                                <v-flex md6>
                                  <div class="block">
                                    <span class="demonstration">Désignation du forfait *</span>
                                    <el-input :disabled="true" :value="'Forfait'" style="width:100%; font-size: 22px"></el-input>
                                  </div>
                                </v-flex>
                            </v-layout>

                            <v-layout row>
                                <v-flex md6>
                                  <div class="block">
                                    <span class="demonstration">Vehicule *</span>
                                    <el-select v-model="selectVehicule" placeholder="Vehicule" style="width:100%">
                                      <el-option v-for="item in listVehicule" :key="item.idVeh" :label="item.libelle" :value="item.idVeh">
                                      </el-option>
                                    </el-select>
                                  </div>
                                </v-flex>
                                <v-flex md6>
                                  <div class="block">
                                    <span class="demonstration">Montant du forfait *</span>
                                    <el-input type="number" name="montant" :min="1" v-model="formAjoutTarif.montant" placeholder="Montant du forfait" style="width:100%"></el-input>
                                  </div>
                                </v-flex>
                            </v-layout>

                            <v-layout row>
                                <v-flex md6>
                                  <div class="block">
                                    <span class="demonstration">Unité (Jour, Mois ou Année) *</span>
                                    <el-select filterable clearable v-model="formAjoutTarif.unite" placeholder="Unité (Jour, Mois ou Année)" style="width:100%">
                                      <el-option v-for="item in listUniteForfait" :key="item.value" :label="item.label" :value="item.value">
                                      </el-option>
                                    </el-select>
                                  </div>
                                </v-flex>
                            </v-layout>
                            <br>
                        </v-form>

                        <v-btn icons color="orange" @click="dialogAjoutTarif = false" dark>Annuler <v-icon right>close</v-icon></v-btn>
                        <v-btn color="primary" @click="saveTarif()" dark>Ajouter <v-icon right>add</v-icon></v-btn>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!--FIN AJOUT FORMULAIRE DE TARIFICATION -->

        <!-- MODAL CONFIRMATION SUPPRESSION-->
        <v-dialog v-model="dialogSuppTarif" width="40%" :overlay="true" scrollable persistent>
            <v-card>
                <v-card-title class="text-xs-center">
                    <h3 class="headline mb-0">Supprimer un tarif</h3>
                    <v-flex xs12>
                        <v-alert outline color="orange darken-1" icon="warning" :value="true">
                            Voulez vous supprimer le forfait de location {{libelForfait}} ou l'ensemble des forfaits appartenant au tarif {{libelTarif}} ?
                            NB : Aucun vehicule possedant ce forfait ne doit etre en cours de location
                        </v-alert>
                    </v-flex>
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click.stop="dialogSuppTarif = false">Annuler</v-btn>
                    <v-btn icons color="red" @click.stop="suppForfait()" dark>Supprimer le forfait
                    </v-btn>

                    <v-btn icons color="red" @click.stop="suppTarif()" dark>Supprimer tous
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--FIN MODAL CONFIRMATION SUPPRESSION-->
    </div>
</template>

<script>
    import Loading from '@/components/Loading';

    export default {
        components: {Loading},
        name: "ModalTarifLocation",
        props: ["show"],
        data() {
            return {
                domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
                user: JSON.parse(sessionStorage.getItem("userInfo")),
                roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
                loading: false,
                selectTarification: null,
                dialogTarifLocation: false,
                itemsTarif: [],
                dialogAjoutTarif: false,
                formAjoutTarif: {},
                dialogAnnule: false,
                formAjoutForfait: {},
                modeEdit: false,
                listVehicule: [],
                listTarif: [],
                dialogSuppTarif: false,
                valid: true,
                libelForfait: null,
                libelTarif: null,
                tarifSelect: false,
                listUniteForfait: [
                    { value: "Heure", label: "Heure" },
                    { value: "Jour", label: "Jour" },
                    { value: "Semaine", label: "Semaine" },
                    { value: "Mois", label: "Mois" },
                    { value: "Année", label: "Année" }
                ],
                tarifCourant: [],
                listVehicule: [],
                selectVehicule: "",
                disabledBtnTar: false,
            }
        },
        computed: {
        },
        watch: {
            show : function(newValue, oldvalue){
                this.dialogTarifLocation = newValue
            }
        },
        methods: {
            loadForfait(){
                let url = this.domaine + "tarification/forfait";
                this.$http.get(url).then(response => {
                    this.itemsTarif = response.body.forfaits;
                    this.nbTarif = response.body.nbTarif;
                    
                });
            },
            loadVehicule () {
                this.loading = true
                let type = 'flotte'
                let url = this.domaine + 'parc/index/type'+'/'+type
                this.$http.get(url).then(response => {
                  if (response.body) {
                    this.listVehicule = response.body.vehicule
                    this.loading = false
                  }
                })        
            },
            loadTarif() {
                let url = this.domaine + "tarification/index";
                this.loading = true;
                this.$http.get(url).then(
                    resp => {
                        this.loading = false
                        this.listTarif = resp.body.tarifications
                        this.nbTarif = resp.body.nbTarif
                    },
                    resp => {
                        this.loading = false
                        this.$message.error(
                            "erreur lors du chargement des tarifs"
                        );
                    }
                );
            },
            loadTarification(queryString, cb) {
                var links = this.listTarif
                var results = queryString ? links.filter(this.createFilter(queryString)) : links;
                cb(results);
            },
            createFilter(queryString) {
                return (link) => {
                  return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            suppForfait(){
                this.loading = true;
                let url = this.domaine + "tarification/delete/forfait/" + this.idForfait;
                this.$http.get(url).then(
                    response => {
                        if (response.body) {
                            this.loading = false;
                            this.$notify({
                                title: "SUPPRESSION",
                                message: response.body.message,
                                type: "success",
                                position: "top-right"
                            });

                            this.dialogSuppTarif = false;
                            this.idForfait = null;
                            this.idTarif = null;
                            this.loadForfait();
                        }
                    },
                    response => {
                        this.$message.error(
                            "Erreur lors de la suppression du forfait"
                        );
                        this.loading = false;
                    }
                );
            },
            closeDialog(){
                this.$emit('close')
            },
            confSuppTarif(item){
                this.libelForfait = item.libelleForfait
                this.libelTarif = item.libelleTarif
                this.idForfait = item.idForfait
                this.idTarif = item.idTarif
                this.dialogSuppTarif = true
            },
            saveTarif() {
                this.loading = true
                if (this.$refs.formAjoutTarifForfait.validate()) {
                    var form = document.getElementById('formAjoutTarifForfait')
                    var data = new FormData(form)
                    data.append('idUser', this.user.id)
                    data.append("tarification", this.selectTarification)
                    data.append("unite", this.formAjoutTarif.unite)
                    data.append("vehicule", this.selectVehicule)
                    if (this.modeEdit == true) {
                        data.append('id', this.tarifCourant.idForfait)
                    } else {
                        data.append('id', "")
                    }

                    let url = this.domaine + "tarification/new";
                    this.$http.post(url, data).then(
                        resp => {
                            let verif = resp.body;
                            this.loading = false;
                            if (verif.code == 1) {
                                this.$notify({
                                    title: "ENREGISTREMENT REUSSI",
                                    message: "Le forfait a été enregistré avec succès.",
                                    type: "success",
                                    position: "top-right"
                                });

                                this.loadForfait();
                                this.dialogAjoutTarif = false
                                this.$refs.formAjoutTarifForfait.reset();
                            } else {
                                this.$message.error("Le forfait n'a pas été enregistré ");
                            }
                        },
                        resp => {
                            this.$refs.formAjoutTarifForfait.reset();
                            this.$message.error(
                                "Erreur lors de l'enregistrement du forfait"
                            );
                            this.loading = false;
                        }
                    );
                }
            },
            editTarification(item) {
                this.tarifCourant = item
                this.modeEdit = true
                this.dialogAjoutTarif = true
                this.selectTarification = item.tarification
                this.formAjoutTarif = {
                    montant: item.montant,
                    unite: item.unite
                }
                this.selectVehicule = item.idVeh
            },
            newTarif() {
                this.tarifCourant = []
                this.$refs.formAjoutTarifForfait.reset();
                this.modeEdit = false
                this.dialogAjoutTarif = true;
                this.selectVehicule = ""
            },
            imprimeListeTarif (type) {
              let url = ""
              if(type == "PDF"){
                  url = this.domaine+"tarification/imprimerPDF/liste"
              }else {
                  url = this.domaine+"tarification/imprimerEXC/liste"
              }
              window.open(url)
          },
        },
        mounted() {
            this.loadForfait()
            this.loadTarif()
            this.loadVehicule()
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/location/TarifLocation.vue